import { Badge } from '@e2n/ui';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faCalendarRange, faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Arbeitsbereich({
  arbeitsbereichStation,
  isNext = false,
}: {
  arbeitsbereichStation: ArbeitsbereichStation;
  isNext?: boolean;
}) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex gap-1 items-center">
        <div className="px-0.5 inline-flex justify-start items-center gap-2">
          <div
            className="min-w-2.5 min-h-2.5 rounded-full"
            style={{
              backgroundColor:
                arbeitsbereichStation.arbeitsbereich.getBorderColor(),
            }}
          />
          <div className="text-xs text-neutrals-900 font-semibold">
            {arbeitsbereichStation.arbeitsbereich.name}
          </div>
        </div>
        {isNext && (
          <Badge type="pill" variant="secondary">
            Geplant ab {dayjs(arbeitsbereichStation.von).format('DD.MM')}
          </Badge>
        )}
      </div>
      <div className="flex gap-4 items-baseline text-xs text-neutrals-700">
        <div className="flex gap-1 items-center">
          <FontAwesomeIcon icon={faCalendarRange} />
          {dayjs(arbeitsbereichStation.von).format('DD.MM.YYYY') +
            ' – ' +
            dayjs(arbeitsbereichStation.bis).format('DD.MM.YYYY')}
        </div>
        {arbeitsbereichStation.abteilungsleiter && (
          <div className="flex items-center gap-1 grow">
            <FontAwesomeIcon icon={faUser} />
            {arbeitsbereichStation.abteilungsleiter.getName()}
          </div>
        )}
      </div>
      <Location standort={arbeitsbereichStation.arbeitsbereich.standort} />
    </div>
  );
}
